import { ArticleFeedbackResponseData } from 'core_main/api/articles/types';
import { h } from 'preact';
import { useContext, useState } from 'preact/hooks';
import Loader from 'widget_main/components/Loader';
import { KBContext } from 'widget_main/store';
import styles from './kbArticleSurvey.scss';
import KBArticleSurveyFeedback from './KBArticleSurveyFeedback/KBArticleSurveyFeedback';
import KBArticleSurveyRating from './KBArticleSurveyRating/KBArticleSurveyRating';

const ArticleSurveySeparator = () => (
  <div className={styles.separatorWrap}>
    <div className={styles.separator} />
    <div className={styles.separator} />
    <div className={styles.separator} />
    <div className={styles.separator} />
  </div>
);

const KBArticleSurvey = () => {
  const kb = useContext(KBContext);
  const { articles, currentArticleId, config } = kb;
  const [surveyResponse, setSurveyResponse] = useState<
    Maybe<ArticleFeedbackResponseData | 'SENT'>
  >(articles?.[currentArticleId || '']?.feedbackSurvey);

  if (
    !config ||
    !config.articleSurvey ||
    config.articleSurvey.enabled === false ||
    !currentArticleId
  )
    return null;

  const article = articles?.[currentArticleId];

  if (!article) return null;
  const updateArticleSurveyResponseState = (
    response: ArticleFeedbackResponseData | 'SENT',
  ) => {
    setSurveyResponse(response);
    if (response !== 'SENT') kb.updateArticleFeedbackResponse(response);
  };
  const renderArticleSurvey = (
    feedbackSurvey: Maybe<ArticleFeedbackResponseData | 'SENT'>,
  ) => {
    if (feedbackSurvey === 'SENT') {
      return (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      );
    }

    if (feedbackSurvey?.id && config.articleSurvey) {
      if (feedbackSurvey.attributes.rating === 'positive') {
        return (
          <div className={styles.confirmationMessage}>
            {config.articleSurvey?.positiveConfirmationMessage}
          </div>
        );
      }
      const noFeedbackRequired =
        !config.articleSurvey.suggestedReasonsEnabled &&
        !config.articleSurvey.writtenFeedbackEnabled;
      const feedbackSent =
        feedbackSurvey.attributes.suggestedReasons?.length ||
        feedbackSurvey.attributes.writtenFeedback;
      if (
        feedbackSurvey.attributes.rating === 'negative' &&
        (noFeedbackRequired || feedbackSent)
      ) {
        return (
          <div className={styles.confirmationMessage}>
            {config.articleSurvey?.negativeConfirmationMessage}
          </div>
        );
      }
      return (
        <KBArticleSurveyFeedback
          articleId={currentArticleId}
          feedbackId={feedbackSurvey.id}
          articleSurveyConfig={config.articleSurvey}
          setSurveyResponse={updateArticleSurveyResponseState}
        />
      );
    }
    return (
      <KBArticleSurveyRating
        articleId={currentArticleId}
        articleSurveyConfig={config.articleSurvey}
        setSurveyResponse={updateArticleSurveyResponseState}
      />
    );
  };
  return (
    <div className={styles.articleSurveyContainer}>
      <ArticleSurveySeparator />
      {renderArticleSurvey(surveyResponse)}
    </div>
  );
};

export default KBArticleSurvey;
